module.exports = __webpack_public_path__ + "img/arrow-down.91d149cd.svg";